export default __webpack_public_path__ + "static/media/SharingiscaringIcon.11774dbb.svg";